export const AUTHENTICATION_CORE_MODULE_NAME = '@pressreader/authentication-core';
